import React from 'react';
import './ndoeUi.css';

/**
 * NdoeStatCard — carte KPI (label majuscule + valeur tabulaire serif).
 *
 * Props :
 *  - label : intitulé
 *  - value : valeur (string|number|node)
 *  - gold  : variante dorée (mise en avant, ex. "Disponible")
 *  - className
 */
export function NdoeStatCard({ label, value, gold = false, className = '' }) {
  return (
    <div className={`ndoe-stat ${gold ? 'ndoe-stat--gold' : ''} ${className}`}>
      <span className="ndoe-stat__label">{label}</span>
      <span className="ndoe-stat__value num">{value}</span>
    </div>
  );
}

/**
 * NdoeStats — grille responsive de cartes KPI (2 colonnes mobile, auto-fit desktop).
 */
export function NdoeStats({ children, className = '' }) {
  return <div className={`ndoe-stats ${className}`}>{children}</div>;
}

export default NdoeStatCard;
